import React, { useState, useEffect, use } from 'react'
import { getNotificationTemplatesList, deleteNotificationTemplateById, getNotificationTemplateSearchBySubjectKeyword, SaveNotificationTemplateByData, UpdateNotificationTemplateByData } from "../ActionCreator";
import Multiselect from "multiselect-react-dropdown";
import ReactQuill from "react-quill";
import ConfirmationPopup from "../../../../presentationals/Popup/ConfirmationPopup.component";
import NodataImage from '../../../../../images/nodata.png'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import AddIcon from '@mui/icons-material/Add';
import Popup from '../../../../presentationals/Popup/Popup.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import { COMPANY_NAME } from '../../../../../utils/api-factory';
import { formatDateNew } from '../../../../../utils/commonUtility';
import Pagination from '@mui/material/Pagination';

const itemsPerPage = 10;
const quillModules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        ["blockquote"],
        [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
        ],
        [{ align: [] }],
        ["link", "image"],
    ],
};

const quillFormats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
    "background",
    "align",
];

const Notification = ({ admin }) => {
    const [loader, setLoader] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const [viewType, setViewType] = useState("list")
    const [showModal, setshowModal] = useState(false)
    const [editData, setEditData] = useState({})
    const [list, setList] = useState([])
     const [listTableData, setlistTableData] = useState([])
        const [currentPage, setcurrentPage] = useState(1)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [deleteData, setDeleteData] = useState({})
    const [objectData, setObjectData] = useState({
        notificationSubject: "",
        notificationText: "",
        notificationDescription: "",
        async: false,
    })

    useEffect(() => {
        getNotificationTemplatesListFn()
    }, []);

    const handlePage = (type, data) => {
        setViewType(type)
        if (type == "add") {
            setEditData(data)
            setObjectData({
                notificationSubject: data?.notificationSubject || "",
                notificationText: data?.notificationText || "",
                notificationDescription: data?.notificationDescription || "",
                async: data?.async || false,
            })
        } else if (type == "list") {
            getNotificationTemplatesListFn()
            setEditData({})
            setObjectData({
                notificationSubject: "",
                notificationText: "",
                notificationDescription: "",
                async: false,
            })
        }
    }

    const cancelLoanConfirm = (type) => {
        if (type == "yes") {
            deleteNotificationTemplateByIdFn(deleteData?.notificationId)
            setshowModal(false)
        } else if (type == "no") {
            setshowModal(false)
            setDeleteData({})
        }
    }

    const handleDelete = (data) => {
        setDeleteData(data)
        setshowModal(true)
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleSearchbtn = (e) => {
        if (e.key == "Enter" && searchValue?.length > 0) {
            getNotificationTemplateSearchBySubjectKeywordFn()
        }
    }

    const changeSearchValue = (e) => {
        setSearchValue(e.target.value)
        if (e.target.value == "") {
            getNotificationTemplatesListFn()
        }
    }

    const handleAddchange = (e, type) => {
        setObjectData((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handleSave = (e) => {
        if (objectData?.notificationSubject === "" || objectData?.notificationSubject === null || objectData?.notificationSubject === undefined) {
            setPopup({ show: true, popupStatus: "Subject Field is Required" })
            removePopup()
        } else if (objectData?.notificationText === "" || objectData?.notificationText === null || objectData?.notificationText === undefined) {
            setPopup({ show: true, popupStatus: "Text Field is Required" })
            removePopup()
        } else if (objectData?.notificationDescription === "" || objectData?.notificationDescription === null || objectData?.notificationDescription === undefined) {
            setPopup({ show: true, popupStatus: "Description Field is Required" })
            removePopup()
        } else if (editData?.notificationId) {
            // update Fn
            const obj = {

                "notificationId": editData?.notificationId,
                "notificationSubject": objectData?.notificationSubject,
                "notificationText": objectData?.notificationText,
                "async": objectData?.async || false,
                "notificationDescription": objectData?.notificationDescription,
                "companyName": COMPANY_NAME,
            }
            UpdateNotificationTemplateByDataFn(editData?.notificationId, obj)

        } else {
            const obj = {
                "notificationSubject": objectData?.notificationSubject,
                "notificationText": objectData?.notificationText,
                "async": objectData?.async || false,
                "notificationDescription": objectData?.notificationDescription,
                "companyName": COMPANY_NAME,
            }
            SaveNotificationTemplateByDataFn(obj)
        }
    }

      const handlePagePagination = (event, value) => {
        setcurrentPage(value);
        const data = filterFunction(listTableData, value)
        setList(data)
    };

    const filterFunction = (data, currentPageNo) => {
        const indexOfLastItem = currentPageNo * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
        return currentItems
    }

    const getNotificationTemplatesListFn = () => {
        setLoader(true)
        getNotificationTemplatesList("",callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.data?.length > 0) {
               const responseData = callback?.data || [];
                setlistTableData(responseData)
                const data = filterFunction(responseData, 1)
                setList(data)
            } else {
                setList([])
            }
        })
    }

    const deleteNotificationTemplateByIdFn = (id) => {
        setLoader(true)
        deleteNotificationTemplateById(id, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Template Deleted Successfully" })
                getNotificationTemplatesListFn()
                setDeleteData({})
            } else {
                setPopup({ show: true, popupStatus: "Error Deleting Template" })
                setDeleteData({})
            }
            removePopup()
        })
    }

    const getNotificationTemplateSearchBySubjectKeywordFn = () => {
        setLoader(true)
        getNotificationTemplateSearchBySubjectKeyword(searchValue, callback => {
            setLoader(false)
            if (callback && callback?.message == "success" && callback?.data?.length > 0) {
                const responseData = callback?.data || [];
                setlistTableData(responseData)
                const data = filterFunction(responseData, 1)
                setList(data)
            } else {
                setList([])
            }
        })
    }

    const SaveNotificationTemplateByDataFn = (data) => {
        setLoader(true)
        SaveNotificationTemplateByData(data, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Data Saved Successfully" })
                setObjectData({
                    notificationSubject: "",
                    notificationText: "",
                    notificationDescription: "",
                    async: false,
                })
            } else if (callback?.data !== null) {
                setPopup({ show: true, popupStatus: callback?.data })
            } else {
                setPopup({ show: true, popupStatus: "Error Saving Data" })
            }
            removePopup()
        })
    }
    const UpdateNotificationTemplateByDataFn = (id, data) => {
        setLoader(true)
        UpdateNotificationTemplateByData(id, data, callback => {
            setLoader(false)
            if (callback && callback?.message == "success") {
                setPopup({ show: true, popupStatus: "Data Updated Successfully" })
                setObjectData({
                    notificationSubject: "",
                    notificationText: "",
                    notificationDescription: "",
                    async: false,
                })
            } else if (callback?.data !== null) {
                setPopup({ show: true, popupStatus: callback?.data })
            } else {
                setPopup({ show: true, popupStatus: "Error Updating Data" })
            }
            removePopup()
        })
    }



    return (
        <>
            <div className="container-fluid marketing-main-css" style={{ margin: '100px 0 40px 0' }}>
                {
                    loader ?
                        <Loader /> : ''
                }
                {showModal ?
                    <ConfirmationPopup cancelLoanConfirm={cancelLoanConfirm} confirmationText={'Are you sure you want to delete this template?'} />
                    : ""}

                {popup?.show ?
                    <Popup closePopup={closePopup} popupStatus={popup?.popupStatus} />
                    : ''}

                <div className="row">
                    <div style={{ display: 'flex', marginBottom: '20px' }}>

                        <button onClick={() => handlePage('list', "")} className="btn" style={{ minWidth:'40px',color: viewType === "list" ? "#fff" : "#000", background: viewType === "list" ? "#337ab7" : '#f4f3f1', padding: '10px', borderRadius: '5px', display: 'flex', margin: '0 16px' }}>
                            <FormatListBulletedIcon style={{ margin: '0', fontSize: '18px', fontWeight: '800' }} />
                        </button>

                        <button onClick={() => handlePage('add', "")} className="btn " style={{ minWidth:'40px',color: viewType === "add" ? "#fff" : "#000", background: viewType === "add" ? "#337ab7" : '#f4f3f1', padding: '10px', borderRadius: '5px', display: 'flex' }}>
                            <AddIcon style={{ margin: '0', fontSize: '18px', fontWeight: '800' }} />
                        </button>

                    </div>

                    {viewType === 'list' ?
                        <div className="col-sm-12 col-xs-12">
                            <div className="row" style={{ marginTop: '15px' }}>
                                <div className="col-lg-2 col-sm-3 col-xs-4">
                                    <label htmlFor=""><i class="fa fa-search" aria-hidden="true"></i>&nbsp;Search</label>
                                    <input className='form-control' placeholder='Search by Subject' type='search' value={searchValue} onChange={(e) => changeSearchValue(e)} onKeyDown={(e) => handleSearchbtn(e)} />
                                </div>
                            </div>
                            <hr />
                            {list !== '' && list?.length > 0 ?
                                <>
                                    <div className="phocket-table-new" style={{ boxShadow: '3px 3px 10px 3px #eee', borderRadius: '15px' }}>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className='text-center'>Subject</th>
                                                    <th className='text-center'>Text</th>
                                                    <th className='text-center'>Description</th>
                                                    <th className='text-center'>Async</th>
                                                    <th className='text-center'>Added On</th>
                                                    <th className='text-center'>Edit</th>
                                                    <th className='text-center'>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list && list?.length > 0 ? list?.map((data, i) => (
                                                    <tr key={i}>
                                                        <td className='text-center'>{data.notificationSubject}</td>
                                                        <td className='text-center'>{data.notificationText}</td>
                                                        <td className='text-center'>{data?.notificationDescription}</td>
                                                        <td className='text-center'>{data.async ? "Yes" : "No"}</td>
                                                        <td className='text-center'>{formatDateNew(data?.creationDate)}</td>
                                                        <td className='text-center'><i style={{ cursor: 'pointer' }} className="fa fa-edit" onClick={() => handlePage('add', data)}></i></td>
                                                        <td className='text-center'><i style={{ cursor: 'pointer' }} className="fa fa-trash" onClick={() => handleDelete(data)}></i></td>
                                                    </tr>
                                                )) : ""}
                                            </tbody>
                                        </table>
                                          <div style={{ float: "right", marginTop: '20px' }}>
                                                                                    <Pagination
                                                                                        count={Math.ceil(listTableData?.length / itemsPerPage)}
                                                                                        page={currentPage}
                                                                                        onChange={handlePagePagination}
                                                                                        color="primary"
                                                                                    />
                                                                                </div>
                                    </div>
                                </>
                                :
                                <div style={{ width: '100%' }} className="text-center"><img style={{ width: '30%', marginTop: '50px', marginLeft: 'auto', marginRight: 'auto' }} src={NodataImage} /></div>}


                        </div>
                        : ""}


                    {viewType === 'add' ?
                        <div className="col-xs-12" style={{ marginTop: '20px' }}>
                            <div className="shadow" style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,.2)', padding: '15px', borderRadius: '6px' }}>
                                <h4 style={{ marginTop: '10px', fontSize: '16px' }}><b>Configure Notification Template</b></h4>
                                <hr style={{ color: '#c7c8c9', borderTop: '3px solid #c7c8c9' }} />


                                <div className="row" style={{ marginTop: '40px' }}>
                                    <div className="col-sm-4 col-xs-12">
                                        <label>Subject</label>
                                        <input type='text' className='form-control' value={objectData?.notificationSubject} onChange={(e) => handleAddchange(e, "notificationSubject")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label>Text</label>
                                        <input type='text' className='form-control' value={objectData?.notificationText} onChange={(e) => handleAddchange(e, "notificationText")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label>Description</label>
                                        <input type='text' className='form-control' value={objectData?.notificationDescription} onChange={(e) => handleAddchange(e, "notificationDescription")} />
                                    </div>


                                </div>

                                <div className="row" style={{ marginTop: '30px' }}>
                                    <div className="col-sm-4 col-xs-12">
                                        <label>Is Async ?</label>
                                        <div className='custom-switch2' style={{ margin: '10px 0 10px 0px' }}>
                                            <label class="switch">
                                                <input type="checkbox" class="checkbox"
                                                    checked={objectData.async}
                                                    onChange={(e) =>
                                                        setObjectData((prev) => ({
                                                            ...prev,
                                                            async: e.target.checked,
                                                        }))
                                                    }
                                                />
                                                <div class="slider"></div>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row" style={{ marginTop: '30px' }}>
                                    <div className="col-xs-12 text-center">
                                        <button className='btn' style={{ padding: '10px 15px', borderRadius: '6px', background: '#337ab7', color: '#fff' }} onClick={(e) => handleSave(e)}>Save</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        : ""}
                </div>


            </div>
        </>
    )
}

export default Notification;
